import createTaskType from '../../createTaskType';
import { cloneDeep, times } from "lodash";
import removePropertiesDeep from "@dyl/utils/removePropertiesDeep";
import PictureEditingEditor from "@dyl/task-types/A2/PictureEditing/Editor";

function createAnswers() {
 return times(3, (i) => ({
   is_correct_answer: i === 0,
   coordinates: {
     top: 0,
     left: 0
   },
   image_id: null,
   text: null
 }));
}

export default createTaskType({
 id: 'picture_editing_a2',
 label: 'Picture Editing',
 skill: 'listening',
 v2: true,
 hasRubric: true,

 backgroundImages: { count: 1 },

 createItemsTemplate: () => times(6, i => ({
   item_type: 'CHOICE',
   is_example: i === 0,
   phase: (i === 0 || i === 1) ? 'PHASE_IMAGE' : null,
   ...(i === 0 || i === 1 ? { answers: createAnswers() } : { answers: [] }),
   ...(i > 1 && {
     phase_selectable: true,
     phase_choices: ['PHASE_IMAGE', 'PHASE_TEXT'],
     phase_answer_templates: {
       PHASE_IMAGE: createAnswers(),
       PHASE_TEXT: createAnswers()
     }
   }),
   ...(i === 0 && {
     rubric_id: ''
   })
 })),

 editor: PictureEditingEditor,

 normalizeLoadedTask(task) {
   task.items = task.items.map((item, index) => {
     if (index > 1 && item.phase && !item.phase_selectable) {
       item.phase_selectable = true;
       item.phase_choices = ['PHASE_IMAGE', 'PHASE_TEXT'];
       item.phase_answer_templates = {
         PHASE_IMAGE: createAnswers(),
         PHASE_TEXT: createAnswers()
       };
     }
     return item;
   });
   return task;
 },

 convertToUploadFormat(task, { isNew }) {
   task = cloneDeep(task);

   task.colors = null;
   delete task.context_audio_id;

    task.items = task.items.map(item => {
      delete item.item_type;

     if (item.phase === 'PHASE_IMAGE') {
       item.answers.forEach(a => delete a.text);
     }

     if (item.phase === 'PHASE_TEXT') {
       item.answers.forEach(a => delete a.image_id);
     }

     delete item.phase_selectable;
     delete item.phase_choices;
     delete item.phase_answer_templates;

     return item;
   });

   if (!isNew) {
     removePropertiesDeep(task, 'label');
   }

   return task;
 },

 rubric: {
   phaseCount: 1
 },

 getKeys: (item) => {
   const correct_answer = item.answers.find(x => x.is_correct_answer);

   if (item.phase === 'PHASE_IMAGE') {
     return [
       `${correct_answer.label} (${correct_answer.coordinates.top}, ${correct_answer.coordinates.left}); Option ${correct_answer.label}-[${correct_answer.image_id}]`
     ];
   }

   if (item.phase === 'PHASE_TEXT') {
     return [
       `${correct_answer.label} (${correct_answer.coordinates.top}, ${correct_answer.coordinates.left}); Option ${correct_answer.label}-[${correct_answer.text}]`
     ];
   }
 },
});